module.exports = __webpack_public_path__ + "static/media/icon-supplies-bathsponge.bfb925ad.svg";